import React from 'react';

type Props = { title: string; handleClick: () => void; isSelected: boolean };

export function PublicationsCategory({ title, handleClick, isSelected }: Props) {
    return (
        <li className={'flex flex-2 flex-col gap-3'} onClick={handleClick}>
            <p
                className={`text-md border ${isSelected ? 'bg-primary' : 'bg-white'} border-light-gray rounded p-5 cursor-pointer`}
            >
                {title}
            </p>
        </li>
    );
}
